import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import LazyImage from "../Loading/lazyImage";

const PROMOTIONITEM = ({
  index,
  specialColor,
  customWidth,
  itemClass,
  originProps,
  url,
}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  return (
    <div
      key={index}
      className={`rounded-[5px] lg:h-[185px] mb-[5px] ${
        customWidth && customWidth
      } ${
        itemClass && itemClass
      } min-w-[110px] bg-main-color group relative cursor-pointer overflow-hidden`}
      onClick={() => {
        navigate(`/promotion/detail/${index}`);
      }}
      style={{ backgroundColor: specialColor }}
    >
      <LazyImage
        className="object-cover h-full w-full group-hover:scale-[1.05] transition duration-300"
        src={url}
      />

      {/* <div
          style={{
            backgroundImage: `url(${url})`,
            backgroundSize: "cover",
            backgroundPosition: "left",
          }}
          className={`w-full h-full absolute group-hover:scale-[1.05] transition duration-300 bg-center bg-no-repeat ${
            hasBottomTitle && "rounded-b-[0px]"
          }`}
        /> */}
      <section className="absolute w-full bottom-0 left-0 h-[96px] text-base-dark dark:text-base-light-white promotion-item-bg">
        <section className="py-[12px] px-[16px]  flex flex-col gap-[5px]">
          <p className="text-lg font-semibold mb-0">{originProps.title}</p>
          <p className="text-sm font-light mb-0">{originProps.subTitle}</p>
        </section>
      </section>
    </div>
  );
};

export default PROMOTIONITEM;
